import { Service } from "models/Service";

export class ArgentinaJersey extends Service {
  constructor() {
    super({
      adsPath: "clarin/mundialfutbol-2026/camisetasarg",
      meta: {
        description: `Camisetas Argentina - Clarin.com`,
        keywords: '',
        title: `Camisetas Argentina - Clarin.com`,
        url: `camiseta-argentina-mundiales`,
        extra: [],
      },
      section: "",
      sectionName: "Camisetas Argentina",
      template: "ArgentinaJerseys",
      title: `Camisetas Argentina`,
      widthFull: true,
      slug: "",
      titleHeader:"",
      showLiveblog: false,
      width100: true,
      classService: "",
      autorefresh : false,
      showBannerH1: false,
      bannerHorizontalOff: ["horizontal3"]
    });    
  }

}